// Port of api/fuel/app/classes/filter/search/games/sorts/query/game/language.php
import { sorted, sortReverse, sortPriority } from 'offline/filter/core/search/unit'
export default {
	name: 'language.dependency',
	post: false,
	require: function(config, filter) { return sorted('language.dependency', filter) > 0 },
	run: function(config, filter, data, query) {
		query.where('g.game_language_dependency', '>', 0)
		query.order('g.game_language_dependency', !sortReverse('language.dependency', filter), sortPriority('language.dependency', filter))
	}
}
